import axios from "../axios/axios";
import { apiSetAlert } from "./appApi";
import { appSetLoading, appSetSendingRequest } from "../store/actions/appAction";
import { selectTableItems } from "../store/actions";
import { errorDispatcher, formatDate, getOptionsQuery, setSelectItemLabels } from "../helpers";
import { setTableData } from "../store/actions/dataTableAction";
import { setEditItem, updateRemittance } from "../store/actions/formAction";
import fileDownload from "js-file-download";
import { DateToString } from "components/Reports/DateFilter";

export const apiGetRemittancesExcel = (token, remittanceType, selectedIds) => (dispatch, getState) => {
  let url = `bills/excel/export?factorTypes=${remittanceType === "enter" ? '["buy", "saleReturn"]' : '["sale", "buyReturn"]'
    }`;
  if (selectedIds && selectedIds.length > 0) {
    url += `&ids=[${selectedIds}]`;
  }
  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      const now = DateToString(Date.now()).replace("/", "_");
      fileDownload(response.data, `remittances_${now}.xlsx`);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetSingleRemittanceExcel = (token, id) => (dispatch, getState) => {
  let url = `bills/excel/exportSingleBill/${id}`;
  dispatch(appSetLoading());
  axios
    .get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    })
    .then((response) => {
      dispatch(appSetLoading(false));
      const now = DateToString(Date.now()).replace("/", "_");
      fileDownload(response.data, `remittances_${now}.xlsx`);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetRemittance = (remittanceId, token, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`bills/${remittanceId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      if (callback) {
        callback(response.data.bill);
      } else {
        const products = [];

        let remittance = response.data.bill;
        const warehouse = setSelectItemLabels(remittance.Warehouse, "id", "title");
        const targetWarehouse = setSelectItemLabels(remittance.TargetWarehouse, "id", "title");
        const project = setSelectItemLabels(remittance.Project, "id", "title");
        const branch = setSelectItemLabels(remittance.Branch, "id", "title");
        // const person = setSelectItemLabels(remittance.Person, "id", "nickName")
        const factor = {
          id: remittance.factor_id,
          value: remittance.factor_id,
          type: remittance.factor?.type,
        };
        const date = formatDate(remittance.date, true, true);
                remittance.Product_Bills.map((p) => {
          products.push({
            product: setSelectItemLabels(p.Product, "id", "title"),
            unit: p.unit === "secondary" ? p.Product.subUnit ?? p.Product.unit : p.Product.unit,
            quantity: +p.quantity,
            description: p.description,
          });
        });
        
        remittance = {
          ...remittance,
          Warehouse: warehouse,
          Project: project,
          person: remittance?.Person,
          date,
        };

        dispatch(updateRemittance('remittance', remittance));
        dispatch(updateRemittance("items", products));
        dispatch(updateRemittance("Warehouse", warehouse));
        dispatch(updateRemittance("TargetWarehouse", targetWarehouse));
        dispatch(updateRemittance("Project", project));
        dispatch(updateRemittance("Branch", branch));
        dispatch(updateRemittance("person", remittance?.Person));
        dispatch(updateRemittance("remittanceFactor", remittance.factor_id ? factor : null));

        dispatch(setEditItem(remittance));
      }
      dispatch(appSetLoading(false));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
export const apiGetRemittanceByFactorId = (factorId, callBack) => (dispatch, getState) => {
  const Token = getState().businessReducer.business?.token;
  const pagination = getState().paginationReducer
  dispatch(appSetLoading(true));

  axios
    .get(`bills/billInfo/${factorId}`, {
      headers: { Authorization: `Bearer ${Token}` },
    })
    .then((response) => {
      if (callBack) {
        callBack(response.data);
      }
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    }).finally(() => dispatch(appSetLoading(false))
    )
}

export const apiGetRemittances =
  ({ pagination, token, key, sort, search }) =>
    (dispatch, getState) => {
      let remittanceType = key;
      if (remittanceType === "exit") {
        remittanceType = '["sale", "buyReturn", "waste"]';
      } else {
        remittanceType = '["buy", "saleReturn"]';
      }

      let options = getOptionsQuery(pagination, search, sort);

      dispatch(appSetLoading());
      axios
        .post(`/bills/list?factorTypes=${remittanceType}`, options, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          dispatch(setTableData(response.data.bills, response.data.paginate));
          // dispatch(setRemittances(response.data.bills));
          dispatch(appSetLoading(false));
        })
        .catch((error) => {
          errorDispatcher(error, dispatch);
        });
    };

export const apiDeleteRemittances = (selectedIds, token, tab, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  dispatch(appSetSendingRequest());
  const billIds = selectedIds;
  axios
    .delete(`/bills/multiple/delete`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { billIds },
    })
    .then((response) => {
      dispatch(selectTableItems([]));
      dispatch(apiSetAlert(response.data.message, "success"));
      if (callback) callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiSaveRemittance = (form, token, navigate, fd, cb) => (dispatch, getState) => {
  // if (!form.factor && form.type !== "transfer") {
  //   dispatch(apiSetAlert("لطفا فاکتور مربوطه را انتخاب نمایید", "error"));
  //   return;
  // }

  const products = [];

  form.items?.map((i) => {
    if (i.product) {
      products.push({
        productId: i.product.id,
        unit: i.unit === "secondary" ? i.product.subUnit ?? i.product.unit : i.product.unit,
        quantity: +i.quantity,
        description: "",
      });
    }
  });
  let factorType;
  switch (form.type) {
    case "transfer":
      factorType = "transfer";
      break;
    case "enter":
    case "exit":
      if (form?.factor && form.factor?.type) {
        factorType = form.factor?.type
      } else if (form.type === "enter") {
        factorType = "noneEnter"
      } else {
        factorType = "noneExit"
      }
      break;
  }
  const formData = {
    accountingCode: form.accountingCodeType ? null : form.accountingCode ?? null,
    date: form.date ? formatDate(form.date) : null,
    description: form.description ?? "",
    WarehouseId: form.Warehouse?.id ?? null,
    targetWarehouseId: form.TargetWarehouse?.id ?? null,
    factorId: form.factor?.id,
    factorType: factorType,
    ProjectId: form.Project?.id ?? null,
    BranchId: form.Branch?.id ?? null,
    transport: form.transport ?? null,
    delivery: form.delivery ?? null,
    PersonId: form?.person?.id,
    products: products,
  };

  dispatch(appSetSendingRequest(true));
  axios
    .post("/bills", fd || formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      if (cb) {
        cb(response.data);
        return;
      }
      if (form.factor) {
        navigate("/remittance");
        // navigate(`/factors/view?factorId=${form.factor.id}&factorType=${form.factor.type}`);
      } else {
        navigate("/remittance");
      }
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiUpdateRemittance = (remittanceId, form, token, navigate, fd, cb) => (dispatch, getState) => {
  const products = [];

  form.items.map((i) => {
    if (i.product) {
      products.push({
        productId: i.product.id,
        unit: i.unit === "secondary" ? i.product.subUnit ?? i.product.unit : i.product.unit,
        quantity: +i.quantity,
        description: i.description,
      });
    }
  });
  let factorType;
  switch (form.type) {
    case "transfer":
      factorType = "transfer";
      break;
    case "enter":
    case "exit":
      if (form?.factor && form.factor?.type) {
        factorType = form.factor?.type
      } else if (form.type === "enter") {
        factorType = "noneEnter"
      } else {
        factorType = "noneExit"
      }
      break;
  }
  const formData = {
    accountingCode: form.accountingCodeType ? null : form.accountingCode ?? null,
    date: form.date ? formatDate(form.date) : null,
    description: form.description ?? "",
    WarehouseId: form.Warehouse?.id ?? null,
    targetWarehouseId: form.TargetWarehouse?.id ?? null,
    factorId: form.factor?.id ?? null,
    factorType: factorType,
    ProjectId: form.Project?.id ?? null,
    BranchId: form.Branch?.id ?? null,
    transport: form.transport ?? null,
    delivery: form.delivery ?? null,
    PersonId: form?.person?.id,
    products: products,
  };

  dispatch(appSetSendingRequest(true));
  axios
    .put(`bills/${remittanceId}`, fd || formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success", false));
      if (cb) {
        cb(response.data);
        return;
      }
      navigate("/remittance");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
